import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ISVG from 'react-inlinesvg';

import { SVG_HOST_URL } from '../utils/config';

import '../scss/_icon.scss';

export const fileTypeIcons = {
  FileTypeXLSX: 'file-types/xlsx.svg',
  FileTypeXLSX2: 'file-types/xlsx2.svg',
  FileTypeCSV: 'file-types/csv.svg',
  FileTypeGIF: 'file-types/gif.svg',
  FileTypeJPEG: 'file-types/jpeg.svg',
  FileTypeJPG: 'file-types/jpg.svg',
  FileTypePNG: 'file-types/png.svg',
  FileTypeMP3: 'file-types/mp3.svg',
  FileTypeWAV: 'file-types/wav.svg',
  FileTypeOGG: 'file-types/ogg.svg',
  FileTypeMP4: 'file-types/mp4.svg',
  FileTypeMOV: 'file-types/mov.svg',
  FileTypeMPEG: 'file-types/mpeg.svg',
};

export const creativesIcons = {
  CreativeImage: 'creative/image.svg',
  CreativeHtml: 'creative/html.svg',
  CreativeGotv: 'creative/gotv.svg',
  CreativeTicker: 'creative/ticker.svg',
  CreativeVideo: 'creative/video.svg',
  CreativeAudio: 'creative/audio.svg',
  CreativeNative: 'creative/native.svg',

  CreativeImageEmptyListPlaceholder: 'creatives/empty-list-placeholder/image.svg',
  CreativeHTMLEmptyListPlaceholder: 'creatives/empty-list-placeholder/html.svg',
  CreativeVideoEmptyListPlaceholder: 'creatives/empty-list-placeholder/video.svg',
  CreativeAudioEmptyListPlaceholder: 'creatives/empty-list-placeholder/audio.svg',

  CreativeImageDescription: 'creatives/creative-description/image.svg',
  CreativeHTMLDescription: 'creatives/creative-description/html.svg',
  CreativeVideoDescription: 'creatives/creative-description/video.svg',
  CreativeAudioDescription: 'creatives/creative-description/audio.svg',
  CreativeNativeDescription: 'creatives/creative-description/native.svg',

  CreativeImageDefaultThumbnailCardView: 'creatives/default-thumbnails/image-cardview.svg',
  CreativeImageDefaultThumbnailTableView: 'creatives/default-thumbnails/image-tableview.svg',
  CreativeHTMLDefaultThumbnailCardView: 'creatives/default-thumbnails/html-cardview.svg',
  CreativeHTMLDefaultThumbnailTableView: 'creatives/default-thumbnails/html-tableview.svg',
  CreativeVideoDefaultThumbnailCardView: 'creatives/default-thumbnails/video-cardview.svg',
  CreativeVideoDefaultThumbnailTableView: 'creatives/default-thumbnails/video-tableview.svg',
  CreativeAudioDefaultThumbnailCardView: 'creatives/default-thumbnails/audio-cardview.svg',
  CreativeAudioDefaultThumbnailTableView: 'creatives/default-thumbnails/audio-tableview.svg',
  CreativeNativeDefaultThumbnailCardView: 'creatives/default-thumbnails/native-cardview.svg',
  CreativeNativeDefaultThumbnailTableView: 'creatives/default-thumbnails/native-tableview.svg',

  CreativeVideoDefaultThumbnail: 'creatives/misc/defaultVideoThumbnail.svg',
  CreativeImageDefaultThumbnail: 'creatives/misc/defaultImageThumbnail.svg',
};

export const audienceIcons = {
  AudienceAdvanced: 'audience/advanced.svg',
  AudienceCampaign: 'audience/campaign.svg',
  AudienceCustom: 'audience/custom.svg',
  AudienceGeo: 'audience/geo.svg',
  AudienceMatched: 'audience/matched.svg',
  AudienceRetargeted: 'audience/retargeted.svg',
  AudienceSegmented: 'audience/segmented.svg',
  AudienceLookalike: 'audience/lookalike.svg',
  AudienceContextual: 'audience/contextual.svg',
};

export const eventsIcons = {
  EventsAppEvent: 'events/app_event.svg',
  EventsCalculated: 'events/calculated.svg',
  EventsConversion: 'events/conversion.svg',
  EventsLocation: 'events/location.svg',
  EventsPixel: 'events/pixel.svg',
  EventsPostBack: 'events/post_back.svg',
  EventsFunnel: 'events/funnel.svg',
};

export const statusIcons = {
  StatusRunning: 'status/status_running.svg',
  StatusRunningColor: 'status/status_running_color.svg',
  StatusPaused: 'status/status_paused.svg',
  StatusPausedColor: 'status/status_paused_color.svg',
  StatusBudgetPaused: 'status/status_budget_pasued.svg',
  StatusBudgetPausedColor: 'status/status_budget_pasued_color.svg',
  StatusPending: 'status/status_pending.svg',
  StatusPendingColor: 'status/status_pending_color.svg',
  StatusDraft: 'status/status_draft.svg',
  StatusDraftColor: 'status/status_draft_color.svg',
  StatusExpired: 'status/status_expired.svg',
  StatusExpiredColor: 'status/status_expired_color.svg',
  StatusDeleted: 'status/status_deleted.svg',
  StatusDeletedColor: 'status/status_deleted_color.svg',
  StatusRejected: 'status/status_rejected.svg',
  StatusRejectedColor: 'status/status_rejected_color.svg',
  StatusApproved: 'status/status_approved.svg',
  StatusApprovedColor: 'status/status_approved_color.svg',
  StatusAll: 'status/status_all.svg',
  StatusAllColor: 'status/status_all_color.svg',
  StatusFailed: 'status/status_failed.svg',
  StatusFailedColor: 'status/status_failed_color.svg',
  StatusReadyColor: 'status/status_ready_color.svg',
  StatusUnusedColor: 'status/status_unused_color.svg',
  StatusProcessingColor: 'status/status_processing_color.svg',
  StatusInvitedColor: 'status/status_invited_color.svg',
};

export const osIcons = {
  OsAmazon: 'os/amazon.svg',
  OsAndroid: 'os/android.svg',
  OsApple: 'os/apple.svg',
  OsChrome: 'os/chrome.svg',
  OsLinux: 'os/linux.svg',
  OsWindows: 'os/windows.svg',
};

export const filterIcons = {
  FilterDma: 'filter/dma.svg',
  FilterRadius: 'filter/radius.svg',
  FilterPolygon: 'filter/polygon.svg',
  FilterZip: 'filter/zip.svg',
  FilterCongress: 'filter/congress.svg',
  FilterSenate: 'filter/senate.svg',
  FilterHouse: 'filter/house.svg',
  FilterCounty: 'filter/county.svg',
  FilterCity: 'filter/city.svg',
  FilterState: 'filter/state.svg',
  FilterReset: 'filter/reset.svg',
};

export const campaignsIcons = {
  CampaignsCreative: 'campaigns/creative.svg',
  CampaignsLocation: 'campaigns/location.svg',
  CampaignsDemographic: 'campaigns/demographic.svg',
  CampaignsInventory: 'campaigns/inventory.svg',
  CampaignsTime: 'campaigns/time.svg',
  CampaignsInfo: 'campaigns/info.svg',
  CampaignsBid: 'campaigns/bid.svg',
  CampaignsAudience: 'campaigns/audience.svg',
  CampaignsBudget: 'campaigns/budget.svg',
  CampaignsStatistic: 'campaigns/statistic.svg',
  CampaignsTechnology: 'campaigns/technology.svg',
  CampaignsStateLaw: 'campaigns/state_law.svg',
  CampaignsKeyWords: 'campaigns/key_words.svg',
  CampaignsEmptyLocations: 'campaigns/empty-locations.svg',
};

export const applicationsIcons = {
  'Manage Users': 'applications/app-1.svg',
  'Manage Customers': 'applications/app-2.svg',
  Finance: 'applications/finances.svg',
  Dashboard: 'applications/dashboard.svg',
  'Campaign Builder': 'applications/campaigns.svg',
  'Creative Builder': 'applications/creatives.svg',
  'Audience Builder': 'applications/audiences.svg',
  'Manage Publishers': 'applications/app-8.svg',
  'Manage Exchanges': 'applications/app-9.svg',
  'Report Builder': 'applications/reports.svg',
  'Voter Intelligence': 'applications/app-11.svg',
  'Campaign Manager': 'applications/app-12.svg',
  'My Profile': 'applications/my-profile.svg',
  Accounts: 'applications/accounts.svg',
  Customers: 'applications/customers.svg',
  'Bid Model': 'applications/bid-model.svg',
  Inventory: 'applications/inventory.svg',
  'Inventory Managment': 'applications/inventory-management.svg',
  Framework: 'applications/framework.svg',
  Segments: 'applications/segments.svg',
  Conversions: 'applications/conversions.svg',
  Organization: 'applications/organization.svg',
  Supertweak: 'applications/supertweak.svg',
  Insights: 'applications/insights.svg',
};

export const creativeIcons = {
  BannerXS: 'banner_xs.svg',
  HtmlXS: 'html_xs.svg',
  gotvXS: 'gotv_xs.svg',
  scrollXS: 'scroll_xs.svg',
  VideoXS: 'video_xs.svg',
  VoiceXS: 'voice_xs.svg',
  NativeAdXs: 'native-ad_xs.svg',
};

export const deviceIcons = {
  Phone: 'phone.svg',
  Tablet: 'tablet.svg',
  Desktop: 'desktop.svg',
  SmartTV: 'smart_tv.svg',
  OtherEmbedded: 'other_embedded.svg',
};

export const commonIcons = {
  CSV: 'csv.svg',
  XLS: 'xls.svg',
  Delete: 'delete.svg',
  DeleteAlt: 'delete-alt.svg',
  Copy: 'copy.svg',
  CopyRounded: 'copy-rounded.svg',
  Spending: 'spending.svg',
  Reorder: 'reorder.svg',
  Checkbox: 'check-box-24px.svg',
  CheckboxBlank: 'check-box-blank-24px.svg',
  CheckCircle: 'check_circle.svg',
  CheckCircleBW: 'check_circle-bw.svg',
  ErrorTriangle: 'error_triangle.svg',
  WarningTriangle: 'warning_triangle.svg',
  AlertTriangle: 'alert_triangle.svg',
  DateRange: 'date_range.svg',
  DragIndicator: 'drag-indicator.svg',
  Apps: 'apps.svg',
  Notification: 'notifications.svg',
  Created: 'created.svg',
  Print: 'print.svg',
  Refresh: 'refresh.svg',
  Updated: 'updated.svg',
  Impressions: 'impressions.svg',
  Close: 'close.svg',
  Add: 'add.svg',
  Plus: 'plus.svg',
  Left: 'left.svg',
  Collapse: 'collapse.svg',
  Right: 'right.svg',
  Expand: 'expand.svg',
  UnfoldMore: 'unfold_more.svg',
  ArrowLeft: 'arrow_left.svg',
  ArrowUp: 'arrow_up.svg',
  ArrowRight: 'arrow_right.svg',
  ArrowMaximize: 'arrow_maximize.svg',
  ArrowMinimize: 'arrow_minimize.svg',
  DownloadRounded: 'download-rounded.svg',
  ArrowDown: 'arrow_down.svg',
  DropDown: 'drop_down.svg',
  DropUp: 'drop_up.svg',
  Report: 'report.svg',
  NoData: 'no_data.svg',
  Search: 'search.svg',
  Marketplace: 'marketplace.svg',
  Edit: 'edit.svg',
  EditAlt: 'edit-alt.svg',
  Eye: 'eye.svg',
  EyeOff: 'eye-off.svg',
  Menu: 'menu.svg',
  MessageDots: 'message_dots.svg',
  Filter: 'filter.svg',
  FilterItems: 'filter_items.svg',
  More: 'more.svg',
  Agenda: 'agenda.svg',
  Done: 'done.svg',
  Sort: 'sort.svg',
  Star: 'star.svg',
  Tap: 'tap.svg',
  Info: 'info.svg',
  List: 'list.svg',
  Table: 'table.svg',
  OneDate: 'one_date.svg',
  AddEmail: 'envelope-add.svg',
  Question: 'question.svg',
  Upload: 'upload.svg',
  People: 'people.svg',
  NoImage: 'no_image.svg',
  Activity: 'activity.svg',
  Advanced: 'advanced.svg',
  Audio: 'audio.svg',
  Circle: 'circle.svg',
  CloseCircle: 'close_circle.svg',
  Conditional: 'conditioanal.svg',
  Customer: 'customer.svg',
  Dollar: 'dollar.svg',
  Dot: 'dot.svg',
  DotLarge: 'dot_large.svg',
  Download: 'download.svg',
  ViewColumn: 'view_column.svg',
  ExpandSide: 'expand_side.svg',
  Group: 'group.svg',
  Link: 'link.svg',
  Location: 'location.svg',
  Lock: 'lock.svg',
  MinusCircle: 'minus_circle.svg',
  OpenLink: 'open_link.svg',
  Pause: 'pause.svg',
  Person: 'person.svg',
  Play: 'play.svg',
  Plugin: 'plugin.svg',
  PlusCircle: 'plus_circle.svg',
  Polygon: 'polygon.svg',
  Radius: 'radius.svg',
  Square: 'square.svg',
  SquareMinus: 'square_minus.svg',
  PrivateDeals: 'private_deals.svg',
  Globe: 'globe.svg',
  Internet: 'internet.svg',
  Mail: 'mail.svg',
  Briefcase: 'briefcase.svg',
  Sharp: 'sharp.svg',
  Address: 'address.svg',
  App: 'app.svg',
  Web: 'web.svg',
  Percentage: 'percentage.svg',
  RadioChecked: 'radio_button_checked.svg',
  RadioUnchecked: 'radio_button_unchecked.svg',
  DollarInSquare: 'dollar-in-square.svg',
  PictureInPicture: 'picture-in-picture.svg',
  HelpCircle: 'help-circle.svg',
  Home: 'home.svg',
  Fingerprint: 'fingerprint.svg',
  Users: 'users.svg',
  ArrowSort: 'arrows-sort.svg',
  Photo: 'photo.svg',
  Crown: 'crown.svg',
  Settings: 'settings.svg',
  Tool: 'tool.svg',
  Invoice: 'invoice.svg',
  Payments: 'payments.svg',
  FileDownload: 'file_download.svg',
  Credit: 'credit.svg',
  SubscriptionPlan: 'add_email.svg',
  EditSquare: 'edit-square.svg',
  Save: 'save.svg',
  Reset: 'reset.svg',
  ShieldLock: 'shield-lock.svg',
  Building: 'building.svg',
  Palette: 'palette.svg',
  UserCheck: 'user_check.svg',
  FileInvoice: 'file_invoice.svg',
  PDF: 'pdf.svg',
  PaymentCard: 'payment-card.svg',
  PaymentPaypal: 'payment-paypal.svg',
  PaymentCheck: 'payment-check.svg',
  Timezone: 'timezone.svg',
  PlayerPause: 'player-pause.svg',
  PlayerPlay: 'player-play.svg',
  EmptyClipboard: 'empty-clipboard.svg',
  responsiveMessage: 'img-responsive-msg.svg',
  AddOutlined: 'add_outlined.svg',
  InsertionOrderBudgetCurrency: 'io_budget_currency.svg',
  InsertionOrderBudgetImpression: 'io_budget_impression.svg',
  Show: 'show.svg',
  CurrencyDollar: 'currency-dollar.svg',
  FileCSV: 'file_csv.svg',
  Calendar: 'calendar.svg',
};

export const iconNameURLMap = {
  ...commonIcons,
  ...creativesIcons,
  ...fileTypeIcons,
  ...audienceIcons,
  ...eventsIcons,
  ...statusIcons,
  ...osIcons,
  ...filterIcons,
  ...campaignsIcons,
  ...applicationsIcons,

  ...creativeIcons,
  ...deviceIcons,
  GenerateProgress: 'gen_report.svg',
  EnabledAdBlockImage: 'EnabledAdBlockImage.svg',
};

const strokeIcons = [
  'ViewColumn',
  'Download',
  'Percentage',
  'DollarInSquare',
  'PictureInPicture',
  'Mail',
  'Tool',
  'Internet',
  'Briefcase',
  'Eye',
  'EyeOff',
  'Home',
  'Fingerprint',
  'Users',
  'ArrowSort',
  'Photo',
  'Crown',
  'Settings',
  'Invoice',
  'Payments',
  'FileDownload',
  'Credit',
  'ShieldLock',
  'Building',
  'UserCheck',
  'FileInvoice',
  'Palette',
  'Globe',
  'PlayerPause',
  'PlayerPlay',
  'EmptyClipboard',
  'MessageDots',
  'CurrencyDollar',
];
const noColorChangeIcons = [
  'App',
  'Web',
  'SmartTV',
  'Phone',
  'Desktop',
  'Tablet',
  'Address',
  'FilterDma',
  'FilterZip',
  'FilterCongress',
  'FilterSenate',
  'FilterHouse',
  'FilterReset',
  'AudienceLookalike',
  'AudienceContextual',
  'FilterCounty',
];
const fillPathIcons = ['Search', 'EditAlt', 'AddEmail', 'HelpCircle'];

export class Icon extends Component {
  render() {
    const { name, className = '' } = this.props;
    const fileName = iconNameURLMap[name] || 'no_image.svg';

    const classNameToSet = [className || ''];

    if (strokeIcons.includes(name)) {
      classNameToSet.push('stroke-icon');
    } else if (noColorChangeIcons.includes(name)) {
      classNameToSet.push('no-color-change-icon');
    } else if (fillPathIcons.includes(name)) {
      classNameToSet.push('fill-path-icon');
    }

    return (
      <ISVG
        preProcessor={(svg) => {
          if (!svg.includes('viewBox=')) {
            const res = `${svg.substring(0, 4)} viewBox="" ${svg.substring(5, svg.length)}`;
            const widthStart = res.substring(res.indexOf('width="') + 7);
            const heightStart = res.substring(res.indexOf('height="') + 8);
            const width = widthStart.substring(0, widthStart.indexOf('"'));
            const height = heightStart.substring(0, heightStart.indexOf('"'));
            return res
              .replace(/\swidth="\S+"\s/, ' ')
              .replace(/\sheight="\S+"\s/, ' ')
              .replace('viewBox=""', `viewBox="0 0 ${width} ${height}"`);
          }
          return svg;
        }}
        uniqueHash={name.toLowerCase().replace(/\s/, '')}
        uniquifyIDs
        className={`svg-icon ${classNameToSet.join(' ')}`}
        src={`${SVG_HOST_URL}/${fileName}`}
        loader={
          <svg
            className={`svg-icon loader ${className}`}
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="24" height="24" />
          </svg>
        }
      />
    );
  }
}

Icon.propTypes = {
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
};
